import React, { FC } from 'react';

type FeTableToolbarProps<T extends object> = {};
export const FeTableToolbar: FC<FeTableToolbarProps<any>> = <T extends object>(props: FeTableToolbarProps<T>) => {
  return <div className='fe-table__toolbar'></div>;
};
